import React, { useState } from 'react';
import { Box, Button, Flex, Image } from 'rebass';
import { keyframes } from '@emotion/core';
import ResponsiveReactPlayer from 'story-media/medium-types/ResponsiveReactPlayer';
import styled from '@emotion/styled';
import { useWindowSize } from 'react-use';
import Welcome_EndFrame2 from '../assets/Welcome_EndFrame2.jpg'
import { filterUTMParams } from 'members/helper';

const growHeight = keyframes`
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
`

const AnimatedButton = styled(Button)`
  transform-origin: center;
  animation: ${growHeight} 0.5s ease-out forwards;
`

const FounderWelcome = () => {
    const [showLearnMore, setShowLearnMore] = useState(false);
    const { width, height } = useWindowSize();

    function getLearnMore() {
        // if (seconds > 112) {
        setShowLearnMore(true)
        // }
        // else
        //     setShowLearnMore(false)
    }

    return <Box sx={{ position: 'fixed', top: 0, bottom: 0, height: [height, '100vh'], width: [width, '100vw'] }}>
        <ResponsiveReactPlayer
            url={'https://s3.us-east-1.amazonaws.com/production.media.lifetales.me/assets/videos/BY-Founder-welcome-postcards.mp4'}
            preload={true}
            controls={!showLearnMore}
            playerWrapper={{ height: 'inherit' }}
            // onSeek={(e) => getLearnMore(e)}
            onStart={() => setShowLearnMore(false)}
            onEnded={() => getLearnMore()}
            style={{
                borderRadius: '10px',
                transformOrigin: 'center',
            }}
            config={{
                file: {
                    attributes: {
                        controlsList: 'nofullscreen',
                        playsInline: true,
                    },
                },
            }}
        />
        {showLearnMore &&
            <Flex flexDirection="column" justifyContent="center" alignItems="center" sx={{
                aspectRatio: '9 / 16',
                height: '100%',
                position: 'fixed',
                top: 0,
                height: '100%',
                left: '50%',
                transform: 'translate(-50%, 0%)',
            }}>
                <Image src={Welcome_EndFrame2} />
                <AnimatedButton
                    mt={["80%", "60%"]}
                    fontFamily='Poppins'
                    bg="brand"
                    sx={{
                        position: 'absolute',
                        borderRadius: '30px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: 'max-content'
                    }}
                    onClick={() => {
                        window.open(`https://babyyearbooks.com/${filterUTMParams(window?.location?.search, '?')}`, '_blank');
                    }}>
                    Learn More
                </AnimatedButton>
            </Flex>
        }
    </Box>

    return null
};

export default FounderWelcome;
